import { createSlice } from '@reduxjs/toolkit';
import jwtDecode from 'jwt-decode';
import Cookies from 'js-cookie';

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: null,
    accessToken: null,
    userData: { FirstName: null, LastName: null },
    ferpaEnabled: null,
    selectedAssignmentId: null,
    accessTokenExpiration: null
  },
  reducers: {
    setCredentials: (state, action) => {
      const { accessToken } = action.payload;
      state.accessToken = accessToken;

      // Get userData and UserName from decoded accessToken
      const decodedToken = jwtDecode(accessToken);
      state.accessTokenExpiration = new Date(decodedToken.exp * 1000).toString();
      state.userData = JSON.parse(
        decodedToken['http://schemas.microsoft.com/ws/2008/06/identity/claims/userdata']
      );
      state.user = decodedToken['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'];
    },
    logOut: (state) => {
      state.user = null;
      state.accessToken = null;
      state.userData = null;
      state.accessTokenExpiration = null;
      Cookies.remove('LOGIN');
      Cookies.remove('SID');
      Cookies.remove('KEY');
    },
    setFerpaState: (state, action) => {
      const { ferpaEnabled } = action.payload;
      state.ferpaEnabled = ferpaEnabled;
    },
    setSelectedAssignmentId: (state, action) => {
      const {assignmentId} = action.payload;
      state.selectedAssignmentId = assignmentId;
    }
  }
});

export const { setCredentials, logOut } = authSlice.actions;
export const { setFerpaState, setSelectedAssignmentId } = authSlice.actions;

export default authSlice.reducer;

export const selectCurrentUser = (state) => state.auth.user;
export const selectCurrentToken = (state) => state.auth.accessToken;
export const selectCurrentUserData = (state) => state.auth.userData;
export const selectFerpaState = (state) => state.auth.ferpaEnabled;
export const selectSelectedAssignmentId = (state) => state.auth.selectedAssignmentId;